import axios from 'axios';
import { ROOT_URL_V2 } from '../config';

export const LOAD_SERVICES_STRUCTURE = 'LOAD_SERVICES_STRUCTURE';

export const fetchServicesStructureAsync = () => axios({
        method: 'GET',
        url: `${ROOT_URL_V2}services/structure/`,
    }).then(response => ({
        type: 'LOAD_SERVICES_STRUCTURE',
        payload: response.data.content,
    })).catch(error => {
        // eslint-disable-next-line no-console
        console.log(error.response);
    });
